import React, { useEffect, useState } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'
import RelatedItems from './RelatedKeyword/RelatedKeyword'
import Button from 'react-bootstrap/Button'
import configData from '../../temp/config'
import { withTranslation } from 'react-i18next'
import './ActivityFilterData.css'
import './ActivityDetailContent.css';
import {isMobile} from 'react-device-detect'

const defaultstarticon = 'fa fa-star-o'

const ActivityDetailContent = (props) => {

  const [detailcontent, setDetailcontent] = useState({
    age: [],
    body: "",
    category: [],
    duration: [],
    filters: [],
    image: "",
    itemId: "",
    keywords: "",
    summary: "",
    thumbnail: "",
    title: ""
  })
  const [iconName, setIconname] = useState(defaultstarticon)

  useEffect(() => {
    setDetailcontent({
      age: props.fields.age,
      body: props.fields.body,
      category: props.fields.category,
      duration: props.fields.duration,
      filters: props.fields.filters,
      image: props.fields.image.value,
      itemId: props.fields.itemId,
      keywords: props.fields.keywords,
      summary: props.fields.summary,
      thumbnail: props.fields.thumbnail,
      title: props.fields.title
    })
  }, [])

  function setRCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    setIconname('fa fa-star')
  }

  const { t } = props

  return (
    <div className="container position-relative">
      {
        detailcontent !== null && detailcontent !== '' && detailcontent !== undefined &&
        <div className="detailpageblk">
          <a className="backtolist" href="/activity-finder">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            {t('ActivityFinder_BackToResults')}
          </a>
          <div className="detailpageintro">
            <div className="bannerimgblk">
              <img src={`${configData.sitecoreApiHost}${detailcontent.image.src}`} className="img-fluid" />
            </div>
            <div className="headerblk">
              <div className="introheading">
                {
                  detailcontent && detailcontent.category.map((item, index) => {
                    return <span>
                      {item.fields.labelName.value}{index + 1 !== detailcontent.category.length && ', '}
                    </span>
                  })
                }
              </div>
              <h1 className="mainheading">
                {detailcontent.title.value}
              </h1>
              <div className="subheading">
                <p className="detailTextWrapper">
                <span className="detailLabelText">{t('ActivityFinder_Age')} </span>
                  <span className="detailDataText"> {
                    detailcontent.age && detailcontent.age.map((item, index) => {
                      return <>{item.fields.labelName.value}{index + 1 !== detailcontent.age.length && ', '}</>
                    })
                  }</span>
                </p>
                <p className="detailTextWrapper">
                <span className="detailLabelText">{t('ActivityFinder_Duration')} </span>
                  <span className="detailDataText">{
                    detailcontent.duration && detailcontent.duration.map((item, index) => {
                      return <>{item.fields.labelName.value}{index + 1 !== detailcontent.duration.length && ', '}</>
                    })
                  }</span>
                </p>
              </div>
              <div className="sharelinks">
                <div className="linkblk">
                  <div className="favoriteblk">
                    <Button variant="link"
                      onClick={() => setRCookie('cname', detailcontent.title.value, window.location.href)}>
                      <i className={iconName} aria-hidden="true"></i>
                      {t('ActivityFinder_Favorite')}
                    </Button>
                  </div>
                  <div className="psharelinks  position-relative">
                    <p className="psharelinks-intro">{t('ActivityFinder_ShareSummary')}</p>
                    {detailcontent.title.value && <Placeholder
                      subject={detailcontent.title.value}
                      name="social-share"
                      rendering={props.rendering}
                      itemid={props.fields.itemId}
                    />}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isMobile && <hr/>}
          <div className="bodycontent bannerdesc">
            <div className="bodycopy" dangerouslySetInnerHTML={{ __html: detailcontent.body.value }} />
          </div>
          {
            detailcontent.keywords.value &&
            <RelatedItems
              keywords={detailcontent.keywords.value}
            //category={getCategory}
            />
          }
          <div class="blk blk-btn blk-btn-backtosearch">
            <a type="button" href="/activity-finder" class="btn btn-p">{t('ActivityFinder_SearchAnotherActivity')}</a>
          </div>
        </div>
      }
    </div>
  )
};

export default withTranslation()(ActivityDetailContent);
